import GoalMenu from './GoalMenu';

export default GoalMenu;
